/**
 * @generated SignedSource<<f67c420f8f4df62c65d42fabd87215da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCustomerUserInput = {
  acceptedLiabilityWaiver: boolean;
  acceptedTermsUsePrivacyAgreement: boolean;
  analyticsTrackingConsent?: boolean | null | undefined;
  email: string;
  emailAssignmentToken?: string | null | undefined;
  firstName: string;
  lastName: string;
  password: string;
  phoneAssignmentToken?: string | null | undefined;
  phoneNumber: string;
};
export type useCreateNewCustomerUserMutation$variables = {
  input: CreateCustomerUserInput;
};
export type useCreateNewCustomerUserMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly session: {
      readonly user: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateNewCustomerUserMutation = {
  response: useCreateNewCustomerUserMutation$data;
  variables: useCreateNewCustomerUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateNewCustomerUserMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateCustomerUserPayload",
        "kind": "LinkedField",
        "name": "createCustomerUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateNewCustomerUserMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateCustomerUserPayload",
        "kind": "LinkedField",
        "name": "createCustomerUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a40ce9dd22cc6f9a1fde2badc5c8c83f",
    "id": null,
    "metadata": {},
    "name": "useCreateNewCustomerUserMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateNewCustomerUserMutation(\n  $input: CreateCustomerUserInput!\n) {\n  responsePayload: createCustomerUser(input: $input) {\n    success\n    session {\n      user {\n        __typename\n        id\n      }\n    }\n    errors {\n      __typename\n      field\n      code\n      message: code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cb9840617e4789a1737c948a886f4fc";

export default node;
